<template>
  <div>
    <Loader v-if="loading" />
    <Navbar />
    <main
      class="relative min-h-screen bg-gradient-to-b from-fs-300 to-fs-400 md:ml-64 md:px-8"
    >
      <h3 class="p-8 text-sm font-semibold text-gray-800 uppercase md:px-14">
        {{ $route.meta.title }}
      </h3>
      <router-view
        v-if="!loading"
        class="max-w-5xl"
      />
    </main>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Navbar from "@/components/Navbar.vue";
import Loader from "@/components/TheLoader.vue";

export default {
  name: "MainLayout",

  components: { Navbar, Loader },

  data: () => ({
    loading: true
  }),

  computed: {
    ...mapGetters(["user", "courses"])
  },

  async mounted() {
    if (!this.user.name) {
      await this.fetchUser();
    }
    if (this.courses.length === 0) {
      await this.fetchAllCourses();
    }
    setTimeout((this.loading = false), 0);
  },

  methods: {
    ...mapActions(["fetchUser", "fetchAllCourses"])
  }
};
</script>
